import { createSlice } from "@reduxjs/toolkit";
import { fetchAgentInteractions } from "./thunk";

interface AgentInteractionsState {
  interactionList: any[];
  isLoading: boolean;
  filterData: {
    page: number;
    limit: number;
    search: string;
    totalCount: number;
  };
}

const initialState: AgentInteractionsState = {
  interactionList: [],
  isLoading: false,
  filterData: {
    page: 1,
    limit: 10,
    search: "",
    totalCount: 0,
  },
};

const agentInteractionsSlice = createSlice({
  name: "agentInteractions",
  initialState,
  reducers: {
    setInteractionFilterData: (state, action) => {
      state.filterData = { ...state.filterData, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgentInteractions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAgentInteractions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.interactionList = action.payload.data;
        state.filterData.totalCount = action.payload.total;
      })
      .addCase(fetchAgentInteractions.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setInteractionFilterData } = agentInteractionsSlice.actions;
export default agentInteractionsSlice.reducer;